import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PhoneAuthContainer from '../../../../../containers/auth/PhoneAuthContainer';
import Button from '../../../../../components/global/Button';

const propTypes = {
  defaultPhone: PropTypes.string,
  onSentPin: PropTypes.func.isRequired,
  onEmailAuth: PropTypes.func.isRequired,
  allowEmailAuth: PropTypes.bool,
  phoneAuthProps: PropTypes.object,
};

const AuthModePhone = ({
  defaultPhone,
  onSentPin,
  onEmailAuth,
  allowEmailAuth,
  phoneAuthProps = {},
}) => {
  return (
    <Fragment>
      <PhoneAuthContainer
        introText=""
        submitText="Send SMS"
        className="login-phone-input-form"
        pinSubmitText="Verify via SMS"
        onSentPin={onSentPin}
        defaultPhone={defaultPhone}
        onEmailAuth={onEmailAuth}
        {...phoneAuthProps}
      />
      <hr />
      {allowEmailAuth && (
        <Fragment>
          <Button
            btnSize="sm"
            btnStyle="link"
            className="text-bold"
            onClick={onEmailAuth}
            data-testid="email-toggle"
          >
            Sign in with email &rarr;
          </Button>
        </Fragment>
      )}
    </Fragment>
  );
};

AuthModePhone.propTypes = propTypes;

export default AuthModePhone;
